module.exports = __webpack_public_path__ + "static/media/microscope.ee088b96.png";